import React from 'react';
import catLogo from '../../images/cat-logo.png';

const IconLogo = () => (
  <img
    src={catLogo}
    alt="Logo"
    style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '50%' }}
  />
);

export default IconLogo;
